
import React from 'react';
import DeckGL from '@deck.gl/react';
import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';
import {Button,Divider,Space,Typography,Modal,Select,Radio,Popover} from 'antd';
import {ExpandOutlined,CloseOutlined,InfoCircleOutlined} from '@ant-design/icons';

import {IconLayer} from '@deck.gl/layers';
import Table from 'components/table/editCell';
 
// import sprite from './spite.png';
import {useParentState} from 'utils';
import {PEITZONE} from 'api'
import {to} from 'utils'
// import PortApp from './PortApp.json';
import Map,{_MapContext as MapContext,Popup,GeolocateControl,NavigationControl,ScaleControl } from 'react-map-gl';//Only works for react-map-gl <=6
import { EditableGeoJsonLayer,ViewMode,DrawPolygonMode,Toolbox  } from 'nebula.gl';

import SplitPane,{Pane,SplitView} from 'components/splitPane';
import SchemaTable from './schemaTable';
import ShapefileUploader from './shpLoader.js'

import {CSVLoader} from '@loaders.gl/csv';
import {ImageLoader} from '@loaders.gl/images';

import Language,{useLanguage} from './language';

// const PortData = PortApp.map(o=>({name:o[0],icon:o[2],lat:o[3],lng:o[4]}))

const MAPBOX_ACCESS_TOKEN = "pk.eyJ1IjoianVsaWVuY291c2luZWF1IiwiYSI6ImNpc2h1OHN2bjAwNzMyeG1za3U0anczcTgifQ.KCp_hDxNidB1n29_yBPXdg";
 
 function getRandomHexColor() {
  // Generate random values for red, green, and blue components
  const red = Math.floor(Math.random() * 256); // Random number between 0 and 255
  const green = Math.floor(Math.random() * 256);
  const blue = Math.floor(Math.random() * 256);

  // Convert decimal values to hexadecimal and format the color code
  const hexRed = red.toString(16).padStart(2, '0'); // Convert to hex and pad with '0' if necessary
  const hexGreen = green.toString(16).padStart(2, '0');
  const hexBlue = blue.toString(16).padStart(2, '0');

  // Combine the components into a full hex color code
  const hexColor = `#${hexRed}${hexGreen}${hexBlue}`;

  return hexColor;
}


const MyPopover = ({id})=><Popover 
                placement="right" 
                overlayStyle={{maxWidth:300,width:300}} 
                trigger="click"
                content={<div><Language id={id}/></div>
                } 
              >
               <InfoCircleOutlined /> 
              </Popover>
const MapContainer = styled.div`
    position: relative;
    width: 100%;
    height: 600px;
`;
 
const Layout=styled.div`
  width:100%;
  padding:6px;
  display: flex;
  flex-direction: column;
`
const Header=styled.div`
  display:flex;
  flex-direction: column;
`;
const Footer=styled.div`
  display:flex;
`;
const RowRight=styled.div`
  display:flex;
  justify-content: space-between;
  
`;
const Row=styled.div`
  display:flex;  
`;
const Body=styled.div`
  display:flex;
`;

const {Title} = Typography


// const schema={
//                   "type": "object",
//                   "properties": {
//                     "id": {
//                       "type": "string",
//                       "format": "uuid"
//                     },
//                     "visible": {
//                       "type": "boolean",
//                       "label":"",
                      
//                     },
//                     "name": {
//                       "type": "string"
//                     },
//                     "color": {
//                       "type": "color",
//                       "format":"hex",
//                       "label":"",
//                     },
//                     "polygon": {
//                       "type": "string",
//                       "hide":true,
//                       "hidden":true,
//                     }
//                   },
//                   "required": ["id", "name","color"]
//                 }

// const _data =[
//   {"id":"A","name":"JULIEN","color":"#00FF00"}
  
  
// ]

const Custom =({Key,title,isEdit,setIsEdit,schema,parent,data,setData,onFinish,tooltipId="MarineLatLongDesc"})=>{
    const [isModal,setIsModal] =React.useState(false);
    const [isOption,setIsOpen] =React.useState("map");
    const [tId,setTId] = React.useState(0);    
      const [mapdata,setMapData] = React.useState([]);
    
    
    const handleUploadFinish=(features)=>{
      onFinish(features);
      closeModal();
      
    }
    
    const closeModal=()=>setIsModal(false);
    
     const columns = [
    {
      title: 'Latitude',
      dataIndex: 'latitude',
      key: 'latitude',
      editable:true,
      type:"number"
      // editable:true
    },
     {
      title: 'Longitude',
      dataIndex: 'longitude',
      key: 'longitude',
      editable:true,
      type:"number"
      
      
    },
    // Add other columns as needed
  ];
    

    const handleSetSaveData=()=>{
      const _ddata=[...mapdata,mapdata[0]];
      onFinish([{
        
        type:"Feature",
        properties:{},
        geometry:{
          type:"Polygon",
          coordinates:[_ddata.map(o=>[o.longitude,o.latitude])]
          }
        }])
      
    }
    
    
    return (<Layout>
    <Header>
       
        <RowRight>          
        <Typography.Title  level={5}>{title}</Typography.Title>
        {isEdit!=Key &&
         <Space>
          <Button size="small" onClick={()=>setIsEdit(Key)}><Language id="add"/></Button>
          <Button size="small" onClick={()=>setIsModal(true)}><Language id="import"/></Button>
        </Space>
        }
        </RowRight>     
      </Header>
      {isEdit==Key ? 
          <div>
        <div>
          <div style={{display:"flex",justifyContent: "space-between"}}>                                                      
            <Radio.Group  
              size="small"
              optionType="button" 
              options={[ { value: "map", label: <Language id="onmap"/> }, { value: "Table", label: <Language id="table"/> }]} 
              onChange={(e)=>console.log(e)||setIsOpen(e?.target?.value)} 
              value={isOption} 
              />         
            <Button size="small" type="text" style={{ marginLeft: 8 }} icon=<CloseOutlined/> onClick={()=>setIsEdit(false)}/>
          </div>
          
          
        </div>                      
      
      
      {isOption=="Table" ?
        <>
        <Typography.Text type="secondary"><Language id={"MarineLatLongDesc"}/></Typography.Text>
        <Divider/>
        {mapdata.length>2 &&<div style={{display:"flex",justifyContent: "flex-end"}}><Button type="primary" disabled={mapdata.length<3} style={{ marginLeft: 8 }} onClick={handleSetSaveData}><Language id="save"/></Button></div>      }
        <Table showHeader={false} rowKey="key" columns={columns} data={mapdata} setData={(d)=>setMapData(d)} />
        <Button style={{ marginLeft: 8 }} onClick={()=>setMapData([...mapdata,{key:tId,latitude:0,longitude:0}])||setTId(tId+1)}><Language id="add"/></Button>
        
        </>:
        <>
        <Typography.Text type="secondary"><Language id={tooltipId}/></Typography.Text>
        </>
      }
      
    </div>:<>
      
      
      
        <SchemaTable  parent={parent} schema={schema} data={data} setData={setData} showAdd={false} showEdit={false} directEdit={true}/>
      
          
      </>
      }
       <Modal
        title={"Import"}
        onCancel={closeModal}
        closable={true}
  	    open={isModal}
  	    footer={null}  	    
  	   
      >
        <ShapefileUploader onFinish={handleUploadFinish}/>
      </Modal>
      
    
    </Layout>) 
}



function hexToRgbaArrayWithAlpha(hex) {
  // Remove the '#' if it's present
  hex = hex.replace('#', '');

  // Handle shorthand hex codes (e.g., "#123" to "#112233")
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }

  // Parse the hex values for red, green, blue, and alpha
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  const a = parseInt(hex.slice(6, 8), 16); // Convert alpha to a float between 0 and 1

  // Return an array with RGBA values
  return [r, g, b, a];
}

const getFillColor = (feature) => {
  
  const hexColor = feature.properties.color;
  const rgbaColor = hexToRgbaArrayWithAlpha(hexColor);
  return rgbaColor;
};

const INITIAL_VIEW_STATE={          
  latitude: 40,
  longitude: -85,
  zoom: 2,
}

const MyMap = ({ schema,parent,data:_data,setData:_setData,onFinish:_onFinish}) => {
  const mapRef = React.useRef()
  const [map, setMap] = React.useState()
  const [data, setData] = useParentState(_data,_setData);
  const {lng="en"} = useLanguage()||{};
  
  const [defaultZones, setDefaultZones] = React.useState([]);
  
  const [geoJsonZone, setGeoJsonZone] = React.useState({"type": "FeatureCollection","features":[]});
  const [geoJsonLocation, setGeoJsonLocation] = React.useState({"type": "FeatureCollection","features":[]});
  
  
  const [isEdit,setIsEdit] =React.useState(false);
  
  
  const {zone:zones,location:locations,vessel:vessels}=data;
  const [viewState, setViewState] = React.useState(INITIAL_VIEW_STATE);
  
  
  const zoneId =  parent?.value?.introduction?.portAuthority;
  
  const loadZones=async()=>{     
    const [err,response]=await to(PEITZONE()) 
    
    return setDefaultZones(response)
  }
  
  React.useEffect(() => {
    loadZones()    
  },[])
  
    const onFinish = (key,features) => {     
      const newArray =features.map(feature=>({
      "id": uuidv4(),
      // "visible":true,
      "active":true,
      "name":feature?.properties?.name ?? "NewZone",
      "color": getRandomHexColor(),
      "geometry":feature.geometry,
      ...key=="location"?{zoneId:undefined}:{}
      
      }))
      setData({...data,[key]:[...data[key]||[],...newArray]});    
      setIsEdit(false)
    };
  
    
  
  const zonesInMap=zones;

  
  
  
  React.useEffect(()=>{
    
    if(!Array.isArray(zonesInMap))return ;    
    const features = zonesInMap.map(({geometry,...properties})=>({"type": "Feature","geometry":geometry||[],properties}));    
    const visibleFeatures = features.filter(o=>o.properties.active);    
    setGeoJsonZone({"type": "FeatureCollection","features":visibleFeatures}); 
  
  },[zonesInMap]);
  
  
  React.useEffect(()=>{
    if(!Array.isArray(locations))return ;    
    const features = locations.map(({geometry,...properties})=>({"type": "Feature","geometry":geometry||[],properties}));    
    const visibleFeatures = features.filter(o=>o.properties.active)    
    setGeoJsonLocation({"type": "FeatureCollection","features":visibleFeatures}); 
  
  },[locations]);
  
 React.useEffect(()=>{
     const zone = defaultZones.find(o=>o.id==zoneId) 
     
    if(zone){     
     const {geometry:{coordinates}={}}=zone;
     const [lng,lat]=coordinates[0][0];
     const view = {"latitude": lat,"longitude": lng,"zoom": 6}     
     setViewState(view)     
    } 
  },[zones,zoneId,defaultZones]);

const ICON_MAPPING = {
  W: {"width":21,"height":21,"x":252,"y":171,"pixelRatio":1,mask: true},//triangle
  WS: {"width":16,"height":17,"x":447,"y":128,"pixelRatio":1,mask: true},//cemetery
  AP: {"width":21,"height":21,"x":105,"y":192,"pixelRatio":1,mask: true},//ferry
  // A: {"width":21,"height":21,"x":222,"y":128,"pixelRatio":1,mask: true},//airport
  A: {"width":21,"height":21,"x":105,"y":192,"pixelRatio":1,mask: true},//airport
  HZ: {"width":17,"height":17,"x":247,"y":64,"pixelRatio":1,mask:true},//circle
  LZ: {"width":17,"height":17,"x":247,"y":64,"pixelRatio":1,mask:true},//circle
  
};

 const layer = new IconLayer({
    id: 'icon-layer',
    data:"https://peit-oiep.s3.amazonaws.com/public/tables/PortApp.csv",
    pickable: true,
    loaders:[CSVLoader,ImageLoader],
    // iconAtlas and iconMapping are required
    // getIcon: return a string
    iconAtlas: "https://peit-oiep.s3.amazonaws.com/public/beta/sprite.png",
    iconMapping: ICON_MAPPING,
    getIcon: d => d.type_code,

    sizeScale: 15,
    getPosition: d => [d.longitude,d.latitude],
    // getSize: d => 5,
    // getColor: d => [Math.sqrt(d.exits), 140, 0]
  });



    const zoneLayer =new EditableGeoJsonLayer({
              id: 'editable-zone-layer',
              data: geoJsonZone,
              mode: isEdit&&isEdit=="zone"? DrawPolygonMode : ViewMode, // Use drawing mode state
              getFillColor: getFillColor,
              stroked: true,
              selectedFeatureIndexes:[],
              onEdit: ({ updatedData,editType }) => {               
                if(editType=="addFeature"){
                    const lastFeature = updatedData.features[updatedData.features.length - 1];                                                                 
                    return onFinish('zone',[lastFeature])
                }                    
                setGeoJsonZone(updatedData);                
              },
            })
     const locationLayer =new EditableGeoJsonLayer({
              id: 'editable-location-layer',
              data: geoJsonLocation,
              mode: isEdit&&isEdit=="location"? DrawPolygonMode : ViewMode, // Use drawing mode state
              getFillColor: getFillColor,
              stroked: true,
              selectedFeatureIndexes:[],
              onEdit: ({ updatedData,editType }) => {               
                if(editType=="addFeature"){
                    const lastFeature = updatedData.features[updatedData.features.length - 1];                                                                 
                    return onFinish('location',[lastFeature])
                }                    
                setGeoJsonLocation(updatedData);                
              },
            })        
  // Called only once map is rendered (async)
  const onRender = React.useCallback(() => {
    
    const mapElem = mapRef?.current
    if (!mapElem) return

    // Saves map reference to state
    setMap(mapElem)
  }, [])
  
  React.useEffect(() => {
    if (map) {
      map.setLanguage("fr") // <= HERE IS THE KEY: This sets the language.
    }
  }, [map])
  
  const a=zoneLayer.getCursor.bind(zoneLayer);
  const b=locationLayer.getCursor.bind(locationLayer);
  return (
    <div style={{display:"flex",flexDirection: "column"}}>
    <SplitView isClose={false} isVersionClose={true}>
    <div>
    <Custom Key="location" title=<Space><Language id="location"/><MyPopover id={"BerthAncDesc"}/></Space> onFinish={(array)=>onFinish("location",array)} schema={schema?.properties?.location} isEdit={isEdit} setIsEdit={setIsEdit} parent={{value:data,parentData:parent}} data={locations} tooltipId={"MarineOnMap2"} setData={(location)=> setData({...data,location})}/>
    <Custom Key="zone" title=<Space><Language id="zone"/><MyPopover id={"ZoneDesc"}/></Space> onFinish={(array)=>onFinish("zone",array)} schema={schema?.properties?.zone} isEdit={isEdit} setIsEdit={setIsEdit} parent={{value:data,parentData:parent}} data={zonesInMap} tooltipId={"MarineOnMap"} setData={(zone)=> setData({...data,zone})}/>
    
    
    </div> 
      <MapContainer>
       <DeckGL
        style={{ width: '100%', height: '100%' }}
          getCursor={(o)=>a(o)=="cell"||b(o)=="cell"?"cell":"grab"}
          ContextProvider={MapContext.Provider} 
          initialViewState={INITIAL_VIEW_STATE}
          // viewState={viewState}
          // onViewStateChange={({ viewState: newViewState }) => setViewState(newViewState)}
          controller={{
            doubleClickZoom: false,
          }}
        layers={[   layer,zoneLayer,locationLayer   ]}
       
        getTooltip={({ object }) => object && `Name: ${lng=="en"?(object?.name||object.properties.name):(object?.nom||object.properties.nom)}`}
      
      >
        <Map  onRender={onRender} ref={mapRef} mapboxApiAccessToken={MAPBOX_ACCESS_TOKEN} key={"map"} mapStyle={"mapbox://styles/mapbox/streets-v9"} />
       </DeckGL> 
       </MapContainer>
  </SplitView>
      <Divider />
      <SchemaTable schema={schema?.properties?.vessel} parent={{value:data,parentData:parent}} data={vessels} setData={(vessel)=>setData({...data,vessel})}/>
     </div>
 
     
  );
};

export default MyMap;
